import { render, staticRenderFns } from "./PictoPlus.vue?vue&type=template&id=54235870&scoped=true&v-once=true&"
var script = {}
import style0 from "./PictoPlus.vue?vue&type=style&index=0&id=54235870&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54235870",
  null
  
)

export default component.exports